/**
 * GERİ BUTONU — bir önceki sayfaya döner, sabit bir hedefe değil.
 *
 * Neden: brief detay sayfasındaki geri butonu her zaman "Brief Keşif Ajanı"na
 * gidiyordu. Kullanıcı oraya genelde ANALİZ sayfasındaki listeden geliyor, dolayısıyla
 * geri tuşu onu listeden koparıp iki adım geriye atıyordu ve listeye dönmek için
 * yeniden tıklamak gerekiyordu ("bi önceki sayfaya gitsin daha kolay oluyor").
 *
 * Uygulama içi geçmiş varsa history.back(), yoksa (sekme doğrudan bu URL ile açılmış
 * olabilir) `yedekHref`e düşer — geri tuşu hiçbir durumda ölü kalmaz.
 */
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export function GeriButon({ yedekHref, yedekEtiket, className }: {
  yedekHref: string;
  yedekEtiket: string;
  className?: string;
}) {
  const [, setLocation] = useLocation();
  // history.length uygulama içi gezinme olup olmadığının kesin ölçüsü değil ama
  // 1 olması "bu sekmede ilk sayfa" demek — o durumda geri gidilecek yer yok.
  const geriVar = typeof window !== "undefined" && window.history.length > 1;
  return (
    <Button
      size="sm" variant="ghost" className={`gap-1.5 ${className ?? ""}`}
      onClick={() => { if (geriVar) window.history.back(); else setLocation(yedekHref); }}
    >
      <ArrowLeft className="w-4 h-4" /> {geriVar ? "Geri" : yedekEtiket}
    </Button>
  );
}
